export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wymagane potwierdzenie"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autoryzację należy potwierdzić jednorazowym kluczem"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autoryzację należy potwierdzić magicznym słowem"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rejestrację należy potwierdzić kodem z wiadomości SMS"])}
}